export enum PAYMENTS_CONFIG_FIELDS {
	PAYMENT_REPORT_TYPE = 'Payment Type',
	SFTP_DESTINATION_SERVER = 'Destination Server',
	SFTP_DESTINATION_PATH = 'Destination Path'
}
